import { render } from "./cinema.vue?vue&type=template&id=43c3e1f2&scoped=true"
import script from "./cinema.vue?vue&type=script&lang=js"
export * from "./cinema.vue?vue&type=script&lang=js"

import "./cinema.vue?vue&type=style&index=0&id=43c3e1f2&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c3e1f2"]])

export default __exports__